import React, { useState } from "react";
import Navbar from "../component/Navbar";

import axios from "axios";
import { url } from "../api/api";
import { useNavigate } from "react-router-dom";
import Activityindicator from "../Activityindicator";
import GridCube from "../img/cubelefts.png"

const Verifyemail = () => {
  const [formData, setFormData] = useState({
    code1: "",
    code2: "",
    code3: "",
    code4: "",
  });

  const [isLoading, setisLoading] = useState(false);
  const [error, seterrorStatus] = useState("");

  const navigate = useNavigate();
  const userid = localStorage.getItem("useridkey");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const concatenateCodes = () => {
    return formData.code1 + formData.code2 + formData.code3 + formData.code4;
  };

  const urll = `${url}/users/verifycode/${userid}`;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setisLoading(true);

    const fullCode = concatenateCodes();

    await axios
      .post(
        urll,
        { code: fullCode },
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then(() => {
        setisLoading(false);
        navigate("/emailsuccess");
      })
      .catch((error) => {
        setisLoading(false);
        if (error.response?.status === 422) {
          seterrorStatus("Code does not exist");
        } else {
          seterrorStatus("Unknown error occurred while submitting the form");
        }
      });
  };

  return (
    <div className="w-full">
      <Navbar />

      {/* Background Section */}
<div
  className=" w-full h-screen flex items-center   justify-center px-4"
  style={{
    background:
      "radial-gradient(93.96% 223.34% at -10.76% 33.62%, #07031C 0%, #241D49 30.52%, #07031C 64.32%)",
  }}
>
  {/* Decorative bottom-left image */}
  <img
    src={GridCube}
    alt="Decorative Graphic"
    className="absolute bottom-4 left-4 w-24 md:w-32 opacity-80 pointer-events-none"
  />

  {/* Verification Card */}
  <div className="w-full md:mt-[-150px]  mt-[-200px] max-w-md rounded-xl border border-white border-opacity-20 p-8 md:p-10 text-center text-white ">
    <h2 className="text-2xl md:text-3xl font-semibold text-[#F2C493] font-istok mb-2">
      Activate Your Account
    </h2>
    <p className="text-sm text-gray-300 mb-8">
      Check Your Email for confirmation code, if you can't find it, check your spam folder
    </p>

    {error && <p className="text-red-500 text-sm mb-4">{error}</p>}

    <form onSubmit={handleSubmit}>
      <div className="flex justify-center gap-4 mb-8">
        {["code1", "code2", "code3", "code4"].map((code, idx) => (
          <input
            key={idx}
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength="1"
            name={code}
            value={formData[code]}
            onChange={handleChange}
            className="w-12 h-12 md:w-14 md:h-14 text-center text-lg md:text-xl rounded-md bg-transparent border border-white border-opacity-30 text-white focus:outline-none focus:ring-2 focus:ring-[#F2C493]"
            required
          />
        ))}
      </div>

      {isLoading ? (
        <Activityindicator />
      ) : (
        <button
          type="submit"
          className="w-full py-3 bg-[#D4F5F9] text-[#00001A] font-medium rounded-md transition duration-200 hover:bg-opacity-80"
        >
          Submit
        </button>
      )}

      <p className="text-sm text-gray-300 mt-4">
        Didn’t Get Any Code?{" "}
        <span className="text-[#F2C493] cursor-pointer underline">
          Resend Code
        </span>
      </p>
    </form>
  </div>
</div>

  
    </div>
  );
};

export default Verifyemail;
